export default "__VITE_ASSET__Dnyo7ecP__"